var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFideliser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(-1244 -4453)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 61,
    cy: 61,
    r: 61,
    transform: "translate(1244 4453)",
    fill: "rgba(30,194,138,0.13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "loyalty",
    transform: "translate(1267.612 4472.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(1.551 6.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 2.375,
    height: 4.75,
    transform: "translate(0 1.679) rotate(-45)",
    fill: "#58a596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(9.387 14.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 2.375,
    height: 4.75,
    transform: "translate(0 1.679) rotate(-45)",
    fill: "#58a596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(1.551 14.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 4.75,
    height: 2.375,
    transform: "translate(0 3.359) rotate(-45)",
    fill: "#58a596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(9.388 6.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 4.75,
    height: 2.375,
    transform: "translate(0 3.359) rotate(-45)",
    fill: "#58a596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(6.801 12.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 2.375,
    height: 2.375,
    fill: "#58a596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(61.767 16.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 2.375,
    height: 4.75,
    transform: "translate(0 1.679) rotate(-45)",
    fill: "#58a596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(69.606 24.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 2.375,
    height: 4.75,
    transform: "translate(0 1.679) rotate(-45)",
    fill: "#58a596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(61.768 24.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 4.75,
    height: 2.375,
    transform: "translate(0 3.359) rotate(-45)",
    fill: "#58a596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(69.605 16.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 4.75,
    height: 2.375,
    transform: "translate(0 3.359) rotate(-45)",
    fill: "#58a596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(67.018 21.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 2.375,
    height: 2.375,
    fill: "#58a596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(0 9.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M60.512,60.663l3.6-4.049-4.56-4.242L60,51.881l-4.469-4.166.7-.739-6.444-6.009-.521.551-1.392-1.292a8.322,8.322,0,0,0,5.891-6.392l.221-1.12L36.934,28.644l-1.819,1.544-9.4-4.322L25.2,26.884A8.32,8.32,0,0,0,27.164,36.94l-1.44,1.223-5.011-2.052-2.025,6.348.013,2.629L14.2,65.509l2,.924L0,89.357l1.94,1.37L18.389,67.445l20.133,9.3,4.8-.564.708,1.062L32.41,79.011,22.241,94.542l1.987,1.3L33.815,81.2l11.668-1.774,10.96,16.427,1.976-1.318L44.488,73.654l-5.578.655L16.928,64.154l.654-2.966,5.063,1.771.784-2.242L18.1,58.852l.916-4.154,5.057,1.769.784-2.242-5.326-1.863,1.232-5.587,5.526,1.933.784-2.242-6-2.1-.008-1.547,1.129-3.539,14.494,5.936-3.04,3.521,4.677,4.352-1.563,1.654,6.444,6.009.8-.847,4.68,4.362,2.45-2.682,4.681,4.354,3.074-3.455L72.832,82.329l1.943-1.365ZM26.961,32.492a5.9,5.9,0,0,1-.065-3.468l6.222,2.861-4.111,3.491A5.893,5.893,0,0,1,26.961,32.492ZM28.2,39.176l9.354-7.942L51.109,34.47a5.946,5.946,0,0,1-5.455,3.7l-.143-.133H44.319l-4.973-.687L36.828,42.71ZM41.2,40l-1.034,1.2.591-1.258ZM36.942,48.56l7.038-8.152h.166c.171.031.342.055.514.076l2.916,2.706-7.628,8.167Zm6.116,8.809L40.132,54.64l.15-.161,9.612-10.167,2.748,2.563Zm6.34,2.6-.846.926-2.913-2.715L53.9,49.441l2.625,2.447-7.163,8.053Zm6.259,2.578-2.919-2.715,5.214-5.708L60.8,56.772Z",
    transform: "translate(0 -25.867)",
    fill: "#58a596"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFideliser);
export default __webpack_public_path__ + "static/media/fideliser.c2063eb5d4ea1bf3f0f0dd5431fdd0ec.svg";
export { ForwardRef as ReactComponent };